import React, { useEffect, useState } from "react"; // ✅ add useEffect
import toast from "react-hot-toast";
import { Mail } from "lucide-react";
import Button from "../UI/Button";
import { apiUrl } from "../../config/api";
import { useNavigate, useLocation } from "react-router-dom"; // ✅ add useLocation

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const location = useLocation(); // ✅

  // ✅ auto-fill email from query string: /forgot-password?email=user@email.com
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const qEmail = params.get("email");
    if (qEmail) setEmail(qEmail);
  }, [location.search]);

const submit = async (e) => {
  e.preventDefault();

  if (!email.trim()) {
    toast.error("Enter your email.");
    return;
  }

  const toastId = "forgot-password";

  try {
    setLoading(true);
    toast.loading("Sending reset link...", { id: toastId });

    const res = await fetch(apiUrl("/api/password/forgot"), {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ email: email.trim() }),
    });

    const data = await res.json().catch(() => ({}));

    toast.success(
      data.message || "If that email exists, a reset link has been sent.",
      { id: toastId }
    );

    navigate("/login");
  } catch (err) {
    console.error(err);
    toast.error("Something went wrong.", { id: toastId });
  } finally {
    setLoading(false);
  }
};

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 dark:bg-gray-950 p-6">
      <div className="w-full max-w-md bg-white dark:bg-gray-900 border border-gray-200 dark:border-gray-800 rounded-3xl p-8 shadow-xl">
        <h1 className="text-2xl font-bold text-gray-900 dark:text-gray-100">Forgot Password</h1>
        <p className="mt-1 text-sm text-gray-600 dark:text-gray-400">
          Enter your email and we’ll send you a reset link.
        </p>

        <form onSubmit={submit} className="mt-6 space-y-4">
          <div>
            <label className="text-sm font-semibold text-gray-700 dark:text-gray-200">Email</label>
            <div className="relative mt-2">
              <Mail className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-500" />
              <input
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="w-full h-11 pl-10 pr-4 rounded-xl border border-gray-200 dark:border-gray-800 bg-white dark:bg-gray-900
                  text-gray-900 dark:text-gray-100 focus:outline-none focus:ring-4 focus:ring-emerald-300/40"
                placeholder="you@email.com"
              />
            </div>
          </div>

          <Button type="submit" loading={loading} className="w-full">
            Send reset link
          </Button>

          <button
            type="button"
            onClick={() => {
                toast("Returning to login");
                navigate("/login");
              }}
            className="w-full text-sm font-semibold text-gray-600 hover:text-gray-800 dark:text-gray-300 dark:hover:text-white"
          >
            Back to login
          </button>
        </form>
      </div>
    </div>
  );
}